// extracted by mini-css-extract-plugin
export var equalColumn = "_ib-0";